<template>
  <div class="dashboard" style="font-size: 0.8rem; margin-top:100px!important">
    <div class="w-100">
      <b-alert
        style="display: flex; justify-content: space-between"
        v-if="wppStatus === 'Conectado'"
        variant="success"
        show
      >
        <span>WhatsApp conectado!</span>
        <span style="font-size: 0.8rem; color: #666">
          {{ me.name }} ({{ me.phone }})
        </span>
      </b-alert>

      <b-alert v-if="wppStatus === 'Desconectado'" variant="warning" show>
        Aguardando conexão com o WhatsApp!
      </b-alert>

      <b-alert
        v-if="wppStatus === 'Aguardando leitura do QRCODE'"
        variant="warning"
        show
      >
        Aguardando leitura do QRCODE
      </b-alert>

      <b-alert v-if="wppStatus === 'STARTING'" variant="danger" show>
        Iniciando WhatsApp...
      </b-alert>
      <div style="">
        <button
          class="btn btn-sm btn-primary mb-3"
          style="font-size: 0.8rem"
          @click="getQrCodePrimary"
          v-if="['Desconectado'].includes(wppStatus)"
        >
          QR Code
        </button>
        <button
          class="btn btn-sm btn-dark mb-3"
          style="font-size: 0.8rem; margin-left: 10px"
          @click="disconnect"
        >
          Reiniciar
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-between mb-2 w-100">
      <h3
        style="
          border-bottom: 3px solid #666;
          color: #666;
          font-size: 1rem;
          width: 100%;
        "
      >
        CRM
      </h3>
    </div>
    <div class="d-flex justify-content-between" style="gap: 20px">
      <div class="w-100">
        <div
          class="input-active-crm"
          v-for="(item, index) in items"
          :key="index"
        >
          <p
            @click="selectItem(item)"
            :style="
              'cursor: pointer;padding-left:5px;font-size:0.8rem;' +
              (itemSelected === item.key ? 'border-left:3px solid green;' : '')
            "
          >
            {{ item.name }}
          </p>
          <input
            :checked="item.active"
            type="checkbox"
            style="cursor: pointer"
            @click="item.active = !item.active"
          />
        </div>
      </div>
      <div class="w-100">
        <textarea
          id="textarea"
          v-model="text"
          placeholder="Escreva aqui a sua mensagem (máximo de 500 caracteres  )"
          rows="8"
          class="form-control"
          maxlength="500"
          :disabled="!itemSelected"
          style="font-size: 0.8rem"
        ></textarea>
        <div class="d-flex justify-content-between mt-2">
          <p style="color: #817c7c">
            Qtd de caracteres: {{ String(text).length }} / 500
          </p>
        </div>
        <div class="w-100" style="display: flex; gap: 20px">
          <div
            style="
              width: 50%;
              heigth: 100px;
              background-color: #fff3cd;
              padding: 10px;
              border-radius: 5px;
            "
          >
            <p style="margin: 0; padding: 0"><b>Legenda:</b></p>
            <div style="white-space: pre-wrap; margin: 0; padding: 0">
              {{ legend }}
            </div>
          </div>
          <div
            style="
              width: 50%;
              heigth: 100px;
              background-color: #e9ecef;
              padding: 10px;
              border-radius: 5px;
            "
          >
            <p style="margin: 0; padding: 0"><b>Informativo:</b></p>
            <div style="white-space: pre-wrap; margin: 0; padding: 0">
              {{ description }}
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <button
            class="btn btn-sm btn-dark mt-3"
            style="font-size: 0.8rem"
            @click="update"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
    <div class="w-100" v-if="wppStatus === 'Aguardando leitura do QRCODE'">
      <img v-if="qrCode" :src="`data:image/png;base64,${qrCode}`" />
    </div>
  </div>
</template>
<script>
import { ServiceWhatsaApp } from "../../services/ServiceWhatsaApp";
import { ITEMS_DEFAULT } from "./constants/index";

export default {
  data() {
    return {
      text: "",
      itemSelected: null,
      items: ITEMS_DEFAULT,
      legend: "",
      description: "",
      id: null,
      qrCode: "",
      wppStatus: null,
      me: {
        phone: "",
        name: "",
      },
    };
  },
  methods: {
    async findCrm() {
      const data = await ServiceWhatsaApp.findall();

      this.id = data.id;
      const backendItems = data.config || [];

      const aux = [];

      for (const element of ITEMS_DEFAULT) {
        const item = backendItems.find((item) => item.key === element.key);

        const selected = ITEMS_DEFAULT.find((e) => e.key === element.key);

        aux.push({
          ...(item || {}),
          key: selected.key,
          name: selected.name,
          active: item ? item.active : selected.active,
          legend: selected.legend,
          description: selected.description,
        });
      }

      this.items = aux;
    },
    selectItem(item) {
      this.itemSelected = item.key;
      this.text = item.message;
      this.legend = item.legend;
      this.description = item.description;
    },
    async update() {
      const itens = this.items.map((item) => {
        if (item.key === this.itemSelected) {
          item.message = this.text;
        }

        return {
          key: item.key,
          active: item.active,
          name: item.name,
          message: item.message,
          legend: item.legend,
          description: item.description,
        };
      });

      await ServiceWhatsaApp.update(this.id, {
        config: itens,
      });

      return this.$toast.open({
        message: "Atualizado com sucesso",
        type: "info",
      });
    },
    async getQrCodePrimary() {
      this.$toast.open({
        message: "Gerando QR Code",
        type: "info",
      });

      const qrcode = await ServiceWhatsaApp.getQrCodePrimary("primary");

      this.qrCode = qrcode;

      this.$toast.open({
        message: "QR Code gerado com sucesso",
        type: "info",
      });
    },
    async disconnect() {
      this.$toast.open({
        message: "Desconectando...",
        type: "info",
      });

      await ServiceWhatsaApp.disconnect("primary");

      this.$toast.open({
        message: "Desconectado com sucesso",
        type: "success",
      });
    },
    async getQrCode() {
      this.$toast.open({
        message: "Gerando QR Code",
        type: "info",
      });

      const qrcode = await ServiceWhatsaApp.getQrCode("primary");

      this.qrCode = qrcode;

      this.$toast.open({
        message: "QR Code gerado com sucesso",
        type: "info",
      });
    },
    async helthCheck() {
      try {
        const status = await ServiceWhatsaApp.healthCheck("primary");
        this.wppStatus = status;

        if (status === "Conectado") {
          this.getMeSession();
        } else if (status === "Aguardando leitura do QRCODE") {
          this.getQrCodePrimary();
        } else if (status === "STARTING") {
          this.wppStatus = "Iniciando WhatsApp...";
        } else {
          this.wppStatus = "Desconectado";
        }
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
    async getMeSession() {
      try {
        const data = await ServiceWhatsaApp.me("primary");
        this.me = {
          phone: data.id.replace("@c.us", "").substring(2),
          name: data.pushName,
        };
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
  },
  mounted() {
    this.findCrm();
    this.helthCheck();
  },
  watch: {
    text(newValue) {
      if (newValue.length > 500) {
        this.text = newValue.slice(0, 500);
      }
    },
  },
};
</script>

<style scoped>
.dashboard {
  width: 85%;
  margin-top: 35px;
}

.input-active-crm p {
  margin: 0;
  font-size: 14px;
}

.input-active-crm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .dashboard {
    width: 90%;
    margin-left: 30px;
  }
}

@media screen and (max-width: 700px) {
  .dashboard {
    width: 100%;
  }
}
</style>